import { useMemo, useState } from 'react'
import {
  saveTransportadora,
  updateTransportadora,
} from '../../../../../services/api/https/registration/transportadora.http'
import { errorHandler } from '../../../../../services/util/error.service'
import * as SystemHttp from '../../../../../services/api/https/system/system.http'

export const LOAD_MESSAGE = {
  NONE: 'NONE',
  NEW_TRANSPORTADORA: 'Salvando transportadora',
  UPDATE_TRANSPORTADORA: 'Atualizando transportadora',
  LOADING_UFS: 'Carregando estados',
  LOADING_CITIES: 'Carregando cidades',
  SUCCESS: 'Operação realizada com sucesso',
}

const INITIAL_TRANSPORTADORA = {
  id: null,
  nome: '',
  cnpj: '',
  uf_id: null,
  city_id: null,
  telefone: '(__)_____-____',
  rntrc: '',
  inscricao_estadual: '',
  actived: true,
}

const INITIAL_STATE = {
  transportadora: { ...INITIAL_TRANSPORTADORA },
  updatedTransportadora: {},
  ufs: [],
  cities: [],
  selectedCity: undefined,
  selectedUf: undefined,
  loadingMessage: LOAD_MESSAGE.NONE,
  errorMessage: null,
}

export default function useTransportadoraModal() {
  const [state, setState] = useState({ ...INITIAL_STATE })

  const localDispatch = useMemo(() => {
    //Helpers
    const validateFieldsWithMask = transportadora => {
      if (transportadora.telefone === '(__)_____-____') transportadora.telefone = null
      if (!transportadora.rntrc) transportadora.rntrc = null
      if (!transportadora.inscricao_estadual) transportadora.inscricao_estadual = null
      return transportadora
    }

    return {
      //Actions
      resetState() {
        setState(prevState => ({
          ...prevState,
          loadingMessage: LOAD_MESSAGE.NONE,
          errorMessage: null,
        }))
      },

      saveTransportadora({ id, ...transportadora }, tpId) {
        saveTransportadora(validateFieldsWithMask(transportadora), tpId)
          .then(updatedTransportadora => {
            setState(prevState => ({
              ...prevState,
              updatedTransportadora: updatedTransportadora,
              transportadora: { ...INITIAL_TRANSPORTADORA },
              selectedCity: undefined,
              selectedUf: undefined,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      updateTransportadora({ city, state, created_at, updated_at, ...transportadora }) {
        updateTransportadora(validateFieldsWithMask(transportadora))
          .then(updatedTransportadora => {
            setState(prevState => ({
              ...prevState,
              updatedTransportadora: updatedTransportadora,
              transportadora: { ...INITIAL_TRANSPORTADORA },
              selectedCity: undefined,
              selectedUf: undefined,
              loadingMessage: LOAD_MESSAGE.SUCCESS,
            }))
          })
          .catch(err =>
            setState(prevState => ({
              ...prevState,
              errorMessage: errorHandler(err),
              loadingMessage: LOAD_MESSAGE.NONE,
            })),
          )
      },

      fetchUFs(ufId = null) {
        SystemHttp.getUfs()
          .then(ufs => {
            if (ufId)
              setState(prevState => ({
                ...prevState,
                ufs: ufs,
                selectedUf: ufs.find(uf => uf.id === ufId),
                loadingMessage: LOAD_MESSAGE.LOADING_CITIES,
              }))
            else
              setState(prevState => ({ ...prevState, ufs: ufs, loadingMessage: LOAD_MESSAGE.NONE }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      fetchCities(ufId, transportadora) {
        SystemHttp.getCities(ufId)
          .then(cities => {
            if (transportadora.id)
              setState(prevState => ({
                ...prevState,
                cities: cities,
                selectedCity: cities.find(city => city.id === transportadora.city_id),
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
            else
              setState(prevState => ({
                ...prevState,
                cities: cities,
                loadingMessage: LOAD_MESSAGE.NONE,
              }))
          })
          .catch(err => setState(prevState => ({ ...prevState, errorMessage: errorHandler(err) })))
      },

      //Events
      onInputChange(name, value) {
        setState(prevState => {
          prevState.transportadora[name] = value
          return { ...prevState }
        })
      },

      onEstadoChange(name, value) {
        setState(prevState => {
          prevState.selectedUf = value
          prevState.transportadora[name] = value.id
          prevState.loadingMessage = LOAD_MESSAGE.LOADING_CITIES
          return { ...prevState }
        })
      },

      onCityChange(name, value) {
        setState(prevState => {
          prevState.selectedCity = value
          prevState.transportadora[name] = value.id
          return { ...prevState }
        })
      },

      onBtnSalvarClick(transportadora) {
        if (transportadora.id)
          setState(prevState => ({
            ...prevState,
            loadingMessage: LOAD_MESSAGE.UPDATE_TRANSPORTADORA,
          }))
        else
          setState(prevState => ({ ...prevState, loadingMessage: LOAD_MESSAGE.NEW_TRANSPORTADORA }))
      },

      onInit(transportadora) {
        setState(prevState => ({
          ...prevState,
          selectedCity: undefined,
          selectedUf: undefined,
          transportadora: transportadora ? transportadora : { ...INITIAL_TRANSPORTADORA },
          loadingMessage: LOAD_MESSAGE.LOADING_UFS,
          telefone: '(__)_____-____',
        }))
      },

      onClose() {
        setState(prevState => ({ ...prevState, transportadora: { ...INITIAL_TRANSPORTADORA } }))
      },
    }
  }, [])

  return { state, localDispatch }
}
